<template>
  <div>
    <b-row>
      <p style="margin-top: 20px">{{ $t("geral.name") + ":" }}</p>
      <b-form-input id="Name" type="text" v-model="model.name" />
      <span class="text-danger" v-if="modelstate['Name']">
        {{ "*" + modelstate["Name"][0] }}
      </span>
    </b-row>
    <!-- {{ model }} -->
    <!-- {{ modelstate }} -->
  </div>
</template>

<script>
export default {
  name: "BrandVehicle",
  props: {
    modelstate: Object,
    model: {
      type: Object,
      required: true,
      default: () => ({
        name: "",
      }),
    },
  },
  data() {
    return {
      options: [],
      localModel: {
        nameParam: "",
      },
    };
  },
  watch: {
    model: {
      handler(newValue) {
        this.localModel.nameParam = newValue.name;
      },
      immediate: true,
    },
    nameParam(value) {
      this.$emit("update:model", { ...this.model, name: value });
    },
  },
};
</script>